import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypotVal = (formData.get('website_alt') as string || '').trim();
    if (honeypotVal) {
      setStatus('success');
      setMessage('订阅成功！感谢你的关注。');
      return;
    }

    if (!email.trim()) return;
    setStatus('loading');

    try {
      const res = await fetch('https://readdy.ai/api/form/d9srd2d8o1vn02ekul10', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email }).toString(),
      });
      const responseText = await res.text();
      let parsed: any = {};
      try { parsed = JSON.parse(responseText); } catch (_e) { /* ignore parse error */ }

      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('订阅成功！感谢你的关注。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
        if (String(serverMsg).includes('spam')) {
          setStatus('error');
          setMessage('提交失败，请稍后再试。');
        } else {
          setStatus('error');
          setMessage(typeof serverMsg === 'string' ? serverMsg : '订阅失败，请稍后再试。');
        }
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查连接后重试。');
    }
  };

  return (
    <section className="py-16 md:py-20 bg-background-950">
      <div className="max-w-2xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
          订阅我们的Newsletter
        </h2>
        <p className="text-background-400 text-sm md:text-base mb-8">
          第一时间获取人渣游戏的最新攻略、更新解读和深度分析文章
        </p>
        <form
          onSubmit={handleSubmit}
          data-readdy-form=""
          className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
        >
          <div className="form-honeypot">
            <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden={true} readOnly />
          </div>
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="输入你的邮箱地址"
            required
            className="flex-1 px-4 py-3 rounded-lg bg-background-800 border border-background-700 text-background-100 placeholder:text-background-500 text-sm focus:outline-none focus:border-primary-500 transition-colors"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="px-6 py-3 rounded-lg bg-primary-500 hover:bg-primary-600 text-white font-label text-sm transition-all duration-200 disabled:opacity-50 cursor-pointer whitespace-nowrap"
          >
            {status === 'loading' ? '提交中...' : '订阅'}
          </button>
        </form>
        {status !== 'idle' && (
          <p className={`mt-4 text-sm ${status === 'success' ? 'text-accent-400' : 'text-red-400'}`}>
            {message}
          </p>
        )}
      </div>
    </section>
  );
}